 const DownloadExcelFile = (data, fileName, contentType) => {
  // ✅ CASE 1: CSV STRING
  if (typeof data === "string") {
    const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${fileName}.csv`;
    link.click();

    URL.revokeObjectURL(url);
    return;
  }

  // ✅ CASE 2: Excel (ArrayBuffer / Uint8Array)
  if (
    data instanceof ArrayBuffer ||
    data instanceof Uint8Array ||
    Array.isArray(data)
  ) {
    const buffer =
      data instanceof ArrayBuffer ? data : new Uint8Array(data);

    const blob = new Blob([buffer], {
      type:
        contentType ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${fileName}.xlsx`;
    link.click();

    URL.revokeObjectURL(url);
    return;
  }

  console.error("Unsupported data format");
};
export default DownloadExcelFile;